module.exports = __webpack_public_path__ + "111906ffd141b481027a6c867e52d3e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/hotline.png
// module id = ./assets/images/footer/hotline.png
// module chunks = 0